import { useEffect, useMemo, useState } from "react";
import { OneLayerObjectsSelectView } from ".";
import { IAutomationObject } from "../../automationObjects";
import { LoadingView } from "../../components";
import { useGetObjects } from "../../hooks/useGetObjects";
import { useGetObjectsChildren } from "../../hooks/useGetObjectsChildren";
import { useGetRelationsOutByIdQuery } from "../../services/objects";
import { onShowChildrenArgs } from "./OneLayerObjectsSelectView";
import { Button } from "baseui/button";
import { useStyletron } from "baseui";
import { VscRefresh } from "react-icons/vsc";

interface IState {
    id: string;
    resourceGroupId: string;
    selectedItem?: IAutomationObject
}

export type onParentChangedArgs = {
    id: string,
    resourceGroupId: string
}
export interface ObjectsSelectViewProps {
    onSelectedItemChanged: (item: IAutomationObject) => void,
    onParentChanged: (args: onParentChangedArgs) => void,
    filter?: (app: IAutomationObject) => boolean | undefined,
    refetchCount: number,
    showSystemApps: boolean,
    currentSelectedParent?: IAutomationObject,
}

const ObjectsSelectView = ({ filter, onSelectedItemChanged, onParentChanged, refetchCount, showSystemApps, currentSelectedParent }: ObjectsSelectViewProps) => {
    const [css,] = useStyletron();
    const [state, setState] = useState<IState>({ id: currentSelectedParent?.id ? currentSelectedParent?.id : '', resourceGroupId: currentSelectedParent?.resourceGroupId ? currentSelectedParent?.resourceGroupId : '', selectedItem: currentSelectedParent ? currentSelectedParent : undefined });
    const hasId = (state.id !== undefined) && (state.id !== '');

    // system apps
    const { data: systemApps, isLoading: systemLoading, isSuccess: systemSuccess, error: systemError } = useGetRelationsOutByIdQuery({ objectId: state.id, resourceGroupId: state.resourceGroupId, type: 'HasConnection' }, { skip: !showSystemApps || !hasId });
    // children apps
    const { children, error: errorChildren, isLoading, isSuccess, refetch: refetchChilds, isFetching } = useGetObjectsChildren(state.resourceGroupId, state.id, showSystemApps || !hasId);
    const { objects: rootObjects, isLoading: isLoadingRoot, isSuccess: isSuccessRoot, error: errorRoot, refetch: refetchRoot, isFetching: isFetchingRoot } = useGetObjects(hasId);

    const childrenSelect = showSystemApps ? systemApps : children;
    const childrenLoading = showSystemApps ? systemLoading : isLoading;
    const childrenSuccess = showSystemApps ? systemSuccess : isSuccess;
    const childrenError = showSystemApps ? systemError : errorChildren;
    const items = useMemo(() => (hasId ? childrenSelect : rootObjects)?.filter((a: any) => filter ? filter(a) : true), [hasId, childrenSelect, rootObjects, filter]);
    const loading = hasId ? childrenLoading : isLoadingRoot;
    const success = hasId ? childrenSuccess : isSuccessRoot;
    const error = hasId ? childrenError : errorRoot;

    function onShowChildren(args?: onShowChildrenArgs) {
        if (args) {
            setState({ id: args.id, resourceGroupId: args.resourceGroupId, selectedItem: undefined });
            if (onParentChanged) onParentChanged({ id: args.id, resourceGroupId: args.resourceGroupId });
        }
    }

    function onSelectionChanged(item: any) {
        setState(prevState => { return { id: prevState.id, resourceGroupId: prevState.resourceGroupId, selectedItem: item } });
        if (onSelectedItemChanged) onSelectedItemChanged(item);
    }

    useEffect(() => {
        if (refetchCount === 0)
            return;
        if (hasId) {
            refetchChilds();
        }
        else {
            refetchRoot();
        }
    }, [refetchCount, hasId]);

    const handleRefresh = () => {
        if (hasId) {
            refetchChilds();
        }
        else {
            refetchRoot();
        }
    }

    const selectedItem = state.selectedItem;

    return (
        <div className={css({ position: 'relative' })}>
            <LoadingView isLoading={loading} isSucess={success} error={error}>
                <Button kind='secondary' shape='circle' className={css({  position: 'absolute', top: '-10px', right: "0px" })} onClick={handleRefresh} isLoading={isFetching || isFetchingRoot}><VscRefresh /></Button>
                <OneLayerObjectsSelectView parentResouceGroupId={state.resourceGroupId} objects={items} selectedItem={selectedItem} onItemSelected={onSelectionChanged} onShowChildren={onShowChildren} parentObjectId={state.id}></OneLayerObjectsSelectView>
            </LoadingView>
        </div>
    )
}


export default ObjectsSelectView;
